<template>
  <div>
    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
    ></DatePicker>

    <Button type="primary" @click="selmachine">查询</Button>
    <Table :columns="columns10" :data="data9"> </Table>

    <Modal
      v-model="modal1"
      title="新增机器"
      width="1000"
      :loading="loading"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="小板号">
            <Input placeholder="请输入小板号" v-model="jiqihao"></Input>
          </FormItem>
          <FormItem label="房间名称">
            <Input placeholder="请输入房间名称" v-model="roomname"></Input>
          </FormItem>
          <FormItem label="房间等级">
            <Input placeholder="请输入房间等级" v-model="roomlv"></Input>
          </FormItem>
          <FormItem label="单价">
            <Input placeholder="请输入单价" v-model="danjia"></Input>
          </FormItem>
          <FormItem label="视频地址">
            <Input placeholder="请输入视频地址" v-model="videourl1"></Input>
          </FormItem>
          <FormItem label="视频地址(副)">
            <Input placeholder="请输入视频地址" v-model="videourl2"></Input>
          </FormItem>
          <FormItem label="输入礼品id">
            <Input placeholder="请输奖励" v-model="jiangli"></Input>
          </FormItem>
          <FormItem label="询奖时间">
            <Input placeholder="请输询奖时间" v-model="wawatime"></Input>
          </FormItem>
          <FormItem label="中奖是否发维护信息">
            <RadioGroup v-model="wintishi">
              <Radio label="是">是</Radio>
              <Radio label="否" checked>否</Radio>
            </RadioGroup>
          </FormItem>

          <single-upload title="上传封面图" @update:image="updateimage1" />
          <single-upload title="上传规则图" @update:image="updateimage2" />
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
import SingleUpload from "@/components/Upload/singleUpload";
import { wawalist } from "../../api/finance";

const OSS = require("ali-oss");
var ossClient = null;
export default {
  components: { SingleUpload },
  data() {
    return {
      modal3: false,
      searchDate: [],
      fengmian: "", //封面图
      guize: "", //规则图
      roomlv: "", //房间等级
      jiqihao: "", //机器号
      duankouhao: "", //端口号
      roomname: "", //房间名称
      danjia: "", //单价
      jiangli: "", //奖励
      wawatime: "10", //询奖时间
      wintishi: "否", //中奖是否发维护信息
      loading: true,
      modal1: false,
      xbid: "", //小板id
      xbsort: 1, //小板座位号
      clickmachineid: "",
      videourl1: "",
      videourl2: "",
      columns10: [
        {
          title: "房间id",
          key: "roomid",
        },
        {
          title: "房间名称",
          key: "roomname",
        },
        {
          title: "机器类型",
          key: "machinetype",
          render: (h, params) => {
            var machinetype = params.row.machinetype == "1" ? "三爪" : "二爪";
            return h("span", machinetype);
          },
        },
        {
          title: "总局数",
          key: "total_games",
        },
        {
          title: "中奖局数",
          key: "winning_games",
        },

        {
          title: "收入总和",
          key: "total_income",
        },

        {
          title: "中奖产出金币",
          key: "win_coinnum",
        },
        {
          title: "利润",
          key: "profit",
        },
        {
          title: "利润率",
          key: "status",
          render: (h, params) => {
            if (params.row.profit === 0 && params.row.total_income === 0) {
              return h("span", "0%");
            }
            const status =
              (
                parseInt(params.row.profit) / parseInt(params.row.total_income)
              ).toFixed(2) *
                100 +
              "%";
            return h("span", status);
          },
        },
        {
          title: "平均出奖率",
          key: "status",
          render: (h, params) => {
            if (
              params.row.winning_games === 0 &&
              params.row.total_games === 0
            ) {
              return h("span", "0%");
            }
            const status =
              (
                parseInt(params.row.winning_games) /
                parseInt(params.row.total_games)
              ).toFixed(2) *
                100 +
              "%";
            return h("span", status);
          },
        },
      ],
      data9: [],
    };
  },
  mounted() {
    this.selmachine();
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    selmachine() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
      };

      wawalist(params).then((res) => {
        console.log("===" + JSON.stringify(res));

        this.data9 = res.data;
      });
    },
    updateimage1(value) {
      this.fengmian = value;
      console.log("updateimage1" + value);
    },
    updateimage2(value) {
      this.guize = value;
      console.log("updateimage2" + value);
    },
    ok() {
      setWawamachine({
        machineid: this.jiqihao,
        roomname: this.roomname,
        roomlv: this.roomlv,
        image: this.fengmian,
        rule: this.guize,
        price: this.danjia,
        reward: this.jiangli,
        wintishi: this.wintishi === "是" ? 1 : 0,
        wawatime: parseInt(this.wawatime),
        videourl1: this.videourl1,
        videourl2: this.videourl2,
        sort: 0,
      })
        .then((res) => {
          this.modal1 = false;
          this.$Message.info("Clicked ok");
        })
        .catch((err) => {});
      //
    },
    cancel() {
      this.$Message.info("Clicked cancel");
    },
    updateMachineStatus(status) {
      updateMachineStatus({ status: status, roomid: this.clickmachineid }).then(
        (res) => {
          this.selmachine();
        }
      );
    },
    guanbimodal() {
      this.modal3 = false;
    },
  },
};
</script>
